<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.estoque.form.unidades"
                    :validations="validations.unidade"
                    label="Unidade"
                    show-default-option
                    textField="nomeFantasia"
                    v-model="model.unidadeId"
                    valueField="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :disabled="!model.unidadeId"
                    :options="data.estoque.form.infraestruturas"
                    :validations="validations.infraestrutura"
                    label="Local de atendimento"
                    show-default-option
                    textField="nome"
                    v-model="model.infraestruturaId"
                    valueField="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :disabled="!model.infraestruturaId"
                    :options="data.estoque.form.centrosCusto"
                    :validations="validations.centroCusto"
                    label="Setor"
                    show-default-option
                    textField="setorNome"
                    v-model="model.centroCustoId"
                    valueField="id"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    color="primary"
                    :label="false"
                    @click="$refs.Form.validate(add)"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
                centroCusto: { required: true },
            }
        }
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('almoxarifado.parametrizacao')
        }
    },
    data: () => ({
        model: {
            unidadeId: null,
            infraestruturaId: null,
            centroCustoId: null,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        loadInfraestrutura() {

            this.setLoading()

            this.repositories.parametrizacao.list({
                origem: 'estoque-minimo-maximo',
                listar: 'infraestruturas',
                unidade_id: this.model.unidadeId
            })
                .then(({ data }) => this.data.estoque.form.infraestruturas = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadCentrosCusto() {

            this.setLoading()

            this.repositories.parametrizacao.list({
                origem: 'estoque-minimo-maximo',
                listar: 'centros-custo',
                infraestrutura_id: this.model.infraestruturaId
            })
                .then(({ data }) => this.data.estoque.form.centrosCusto = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        add() {

            const centroCustoJaIncluido = this.data.estoque.model.centrosCusto
                .find(cc => cc.id === this.model.centroCustoId)

            if (centroCustoJaIncluido) {

                this.showValidationNotification('Este centro de custo já foi incluído.')

                return;
            }

            this.data.estoque.model.centrosCusto.push({
                id: this.model.centroCustoId,
                unidadeNomeFantasia: this.data.estoque.form.unidades.find(u => u.id === this.model.unidadeId).nomeFantasia,
                localAtendimentoNome: this.data.estoque.form.infraestruturas.find(i => i.id === this.model.infraestruturaId).nome,
                setorNome: this.data.estoque.form.centrosCusto.find(cc => cc.id === this.model.centroCustoId).setorNome,
                grupos: [],
                isSaved: false,
            })

            this.resetForm()
        },
        resetForm() {

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.centroCustoId = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        }
    },
    mixins: [repository, error],
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        'data.estoque.form.infraestruturas'(infraestruturas) {

            if (infraestruturas.length === 1) {

                this.model.infraestruturaId = infraestruturas[0].id
            }
        },
        'data.estoque.form.centrosCusto'(centrosCusto) {

            if (centrosCusto.length === 1) {

                this.model.centroCustoId = centrosCusto[0].id
            }
        },
        'model.unidadeId'(unidadeId) {

            this.model.infraestruturaId = null

            if (unidadeId) {

                this.loadInfraestrutura()
            }
        },
        'model.infraestruturaId'(infraestruturaId) {

            this.model.centroCustoId = null

            if (infraestruturaId) {

                this.loadCentrosCusto()
            }
        },
    }
}
</script>